import React, { Component } from 'react'
import './Distributors.css'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import Search from '../../images/search.jpg'
import whitePlus from '../../images/whiteplus.png'
import { getDistributors, sortUsers, setSearchParams, paginationUsers } from '../../actions/distributor'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import Pagination from '../Common/Pagination'
import { Config } from '../../Config'
import AuthenticationService from '../Security/AuthenticationService'
import CommonLoader from '../Alerts/CommonLoader'
class DistributorList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      language: languageSettings.getCurrentLanguage(),
      Ascending: true,
      criteria: null,
      pageSize: 10,
      offset: 0,
      url: null,
      userContext: {},
      token: null,
      recordCount: 0,
      pageNumber: null,
      distributors: [],
      showCommonLoader: true,
      forcePage: null
    }

    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.PageSizeValueDropdown = this.PageSizeValueDropdown.bind(this)
    this.PageClicked = this.PageClicked.bind(this)
    this.renderDistrbuteUsers = this.renderDistrbuteUsers.bind(this)
    this.search = this.search.bind(this)
  }

  componentWillMount () {
    this.props.sortUsers({ 'sortBy': 'User_EmailAddress', 'sortType': 'ASC' })
    this.props.setSearchParams({ 'criteria': null })
    this.props.getDistributors(() => {
      this.setState({ showCommonLoader: false })
    })
  }

  handleCriteria (e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  onEnterPress (e) {
    if (e.key === 'Enter') {
      this.setState({ showCommonLoader: true })
      this.props.setSearchParams({ 'criteria': this.state.criteria })
      if (this.state.criteria === '' || this.state.criteria === null) {
        this.PageClicked(0)
      }

      this.props.getDistributors(() => {
        this.setState({ showCommonLoader: false })
      })
    }
  }
  search () {
    this.setState({ showCommonLoader: true, forcePage: 0, offset: 0 })
    this.props.setSearchParams({ 'criteria': this.state.criteria })
    if (this.state.criteria === '' || this.state.criteria === null) {
      this.PageClicked(0)
      window.location.href = '/admin/distributors'
    }
    this.props.getDistributors(() => {
      this.setState({ showCommonLoader: false })
    })
  }

  sortStores (e) {
    this.state.Ascending = !this.state.Ascending
    this.setState(this.state)
    this.setState({ showCommonLoader: true })
    let sortBy = e.target.id
    let sortType = this.state.Ascending ? 'ASC' : 'DESC'
    let sortParams = { 'sortBy': sortBy, 'sortType': sortType }
    this.props.sortUsers(sortParams)
    this.props.getDistributors(() => {
      this.setState({ showCommonLoader: false })
    })
  }

  PageSizeValueDropdown (pageSize) {
    this.setState({ showCommonLoader: true, forcePage: 0, offset: 0 })
    this.setState({ pageSize })
    let paginationParams = { pageSize: pageSize, pageNumber: 1 }
    this.state.offset = 0
    this.props.paginationUsers(paginationParams)
    this.props.getDistributors(() => {
      this.setState({ showCommonLoader: false })
    })
  }
  PageClicked (value) {
    this.setState({ showCommonLoader: true })
    let paginationParams = { pageSize: this.state.pageSize, pageNumber: ((value / this.state.pageSize) + 1) }
    this.setState({ pageNumber: paginationParams.pageNumber })
    this.props.paginationUsers(paginationParams)
    this.props.getDistributors(() => {
      this.setState({ showCommonLoader: false })
    })
    if (value === null) {
      return this.state.offset
    } else {
      this.state.offset = value
      return this.state.offset
    }
  }

  editDistributor (uuid) {
    window.location.href = '/admin/account?type=distributor&useruid=' + uuid
  }
  addDistributor () {
    window.location.href = '/admin/account?type=distributor'
  }

  renderMain () {
    let sortParams = (this.props.Distributordata.sortParams) ? this.props.Distributordata.sortParams : { 'sortBy': 'User_EmailAddress', 'sortType': 'DESC' }
    let recordCount = (this.props.Distributordata.distributors.pageDetails !== undefined) ? this.props.Distributordata.distributors.pageDetails.RecordCount : 10
    let pageCount = (this.props.Distributordata.distributors.pageDetails !== undefined) ? this.props.Distributordata.distributors.pageDetails.TotalPages : 1
    const { language } = this.state
    return (
      <section id='distributor' className='distributor'>
        <div className='settings forms'>
          <div className='settings_plug clear'>
            <h3 className='clear'>{t[language].distributors}</h3>
            <div className='distributor_search clear'>
              <div className='addDistributor'>
                <a className='AddDistributor' onClick={this.addDistributor.bind(this)}>
                  <span className='additem'>
                    <img src={whitePlus} alt='Device Online' onClick={this.search.bind(this)} />{t[language].AddDistributor}
                  </span>
                </a>
              </div>
              <div className='searchArea'>
                <div className='form1'>
                  <input name='criteria' type='text' className='searchbox searchbox_home' value={this.state.criteria} onChange={this.handleCriteria.bind(this)} onKeyPress={this.onEnterPress.bind(this)} />
                  <img type='image' src={Search} className='searchbox_submit searchbox_submit_home' onClick={this.search} alt='search' />
                </div>
              </div>
            </div>
          </div>
          <div className='settings_table'>
            <div className='ctable'>
              <Table>
                <Thead>
                  <Tr className='theader clear'>
                    <Th />
                    <Th className={(sortParams.sortBy === 'User_EmailAddress' && sortParams.sortType === 'ASC')
                      ? 'actcold' : ((sortParams.sortBy === 'User_EmailAddress' && sortParams.sortType === 'DESC')
                        ? 'actcol' : '')}>
                      <a><span id='User_EmailAddress' onClick={this.sortStores.bind(this)}>{t[language].username}</span></a>
                    </Th>
                    <Th className={(sortParams.sortBy === 'Company_Name' && sortParams.sortType === 'ASC')
                      ? 'actcold' : ((sortParams.sortBy === 'Company_Name' && sortParams.sortType === 'DESC')
                        ? 'actcol' : '')}>
                      <a><span id='Company_Name' onClick={this.sortStores.bind(this)}>{t[language].distributorName}</span></a>
                    </Th>
                    <Th className={(sortParams.sortBy === 'Company_AvanteCust_ID' && sortParams.sortType === 'ASC')
                      ? 'actcold' : ((sortParams.sortBy === 'Company_AvanteCust_ID' && sortParams.sortType === 'DESC')
                        ? 'actcol' : '')}>
                      <a><span id='Company_AvanteCust_ID' onClick={this.sortStores.bind(this)}>{t[language].avantenum}</span></a>
                    </Th>
                    <Th className={(sortParams.sortBy === 'Subscription_Name' && sortParams.sortType === 'ASC')
                      ? 'actcold' : ((sortParams.sortBy === 'Subscription_Name' && sortParams.sortType === 'DESC')
                        ? 'actcol' : '')}>
                      <a><span id='Subscription_Name' onClick={this.sortStores.bind(this)}>{t[language].HelpSubscription_type}</span></a>
                    </Th>
                    <Th className={(sortParams.sortBy === 'Account_StartDate' && sortParams.sortType === 'ASC')
                      ? 'actcold' : ((sortParams.sortBy === 'Account_StartDate' && sortParams.sortType === 'DESC')
                        ? 'actcol' : '')}>
                      <a><span id='Account_StartDate' onClick={this.sortStores.bind(this)}>{t[language].StartDate}</span></a>
                    </Th>
                    <Th className={(sortParams.sortBy === 'Account_EndDate' && sortParams.sortType === 'ASC')
                      ? 'actcold' : ((sortParams.sortBy === 'Account_EndDate' && sortParams.sortType === 'DESC')
                        ? 'actcol' : '')}>
                      <a><span id='Account_EndDate' onClick={this.sortStores.bind(this)}>{t[language].EndDate}</span></a>
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {!this.state.showCommonLoader ? this.renderDistrbuteUsers() : '' }
                </Tbody>
              </Table>
              <div className='distributorLoader'>
                {this.state.showCommonLoader
                  ? <CommonLoader showLoader={this.state.showCommonLoader} message={'Loading...'} /> : ''
                }
              </div>
              <div>
                <Pagination
                  perPage={this.state.pageSize}
                  PageSizeValueChange={this.PageSizeValueDropdown}
                  offset={this.PageClicked}
                  recordCount={recordCount}
                  pageCount={pageCount}
                  offSetValue={this.state.offset}
                  forcePage={this.state.forcePage}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

    )
  }

  render () {
    if (this.authService.isAdmin()) {
      return this.renderMain()
    } else {
      window.location.href = '/myAccount'
      return <div />
    }
  }

  renderDistrbuteUsers () {
    let self = this
    let distributorUserList
    const { language } = this.state
    if (this.props.Distributordata.distributors && this.props.Distributordata.distributors !== undefined && (this.props.Distributordata.distributors.data !== undefined || this.props.Distributordata.distributors.pageDetails !== undefined)) {
      if (this.props.Distributordata.pageDetails && (this.props.Distributordata.pageDetails.RecordCount === 0 || this.props.Distributordata.pageDetails.RecordCount === undefined || this.props.Distributordata.pageDetails.RecordCount === null) && this.props.Distributordata.distributors.status === false) {
        return (
          <Tr className='tdata clear'>
            <Td colSpan='7'> <h3>No Distributors Found</h3> </Td>
          </Tr>
        )
      } else {
        distributorUserList = this.props.Distributordata.distributors.data.map(function (distributor, index) {
          let subscriptionName = typeof distributor.Subscription_Name === 'string' ? distributor.Subscription_Name.split(' ')[0] : ''
          return (
            <Tr className='tdata clear' key={index}>
              <Td className='cdet'> <a className='opener view_details' onClick={() => self.editDistributor(distributor.User_UID)} >{t[language].viewedit} <br /> {t[language].User}</a> </Td>
              <Td>{distributor.User_EmailAddress} </Td>
              <Td>{distributor.Company_Name}</Td>
              <Td>{distributor.Company_AvanteCust_ID}</Td>
              <Td>{subscriptionName}</Td>
              <Td>{distributor.Account_StartDate}</Td>
              <Td>{distributor.Account_EndDate} </Td>
            </Tr>
          )
        })
      }

      return distributorUserList
    }
  }
}

function mapStateToProps (state) {
  return {
    Distributordata: state.distributor
  }
}
function mapDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      setSearchParams: setSearchParams,
      getDistributors: getDistributors,
      sortUsers: sortUsers,
      paginationUsers: paginationUsers
    }, dispatch
  )
}
export default connect(mapStateToProps, mapDispatchToProps)(DistributorList)



// WEBPACK FOOTER //
// ./src/components/Distributors/DistributorList.js